var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", [
      _c("div", [
        _c("article", { staticClass: "box" }, [
          _c("p", { staticClass: "title" }, [_vm._v("Annotations")]),
          _c("div", { staticClass: "columns" }, [
            _c("div", { staticClass: "column" }, [
              _c("div", { staticClass: "field" }, [
                _c("label", { staticClass: "label" }, [_vm._v("RR")]),
                _c(
                  "div",
                  {
                    staticClass: "control",
                    class: {
                      "is-loading": _vm.savingAnnotations[_vm.remarkTypes.RR],
                    },
                  },
                  [
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.getAnnotation(_vm.remarkTypes.RR).remarks,
                          expression: "getAnnotation(remarkTypes.RR).remarks",
                        },
                      ],
                      staticClass: "textarea",
                      attrs: {
                        rows: _vm.rows,
                        disabled: !!_vm.savingAnnotations[_vm.remarkTypes.RR],
                      },
                      domProps: {
                        value: _vm.getAnnotation(_vm.remarkTypes.RR).remarks,
                      },
                      on: {
                        focus: function ($event) {
                          return _vm.captureAnnotationSnapshot(
                            _vm.remarkTypes.RR
                          )
                        },
                        blur: function ($event) {
                          return _vm.handleAnnotationBlur(_vm.remarkTypes.RR)
                        },
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.getAnnotation(_vm.remarkTypes.RR),
                            "remarks",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]
                ),
              ]),
              _c("div", { staticClass: "field" }, [
                _c("label", { staticClass: "label" }, [_vm._v("REP")]),
                _c(
                  "div",
                  {
                    staticClass: "control",
                    class: {
                      "is-loading": _vm.savingAnnotations[_vm.remarkTypes.REP],
                    },
                  },
                  [
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.getAnnotation(_vm.remarkTypes.REP).remarks,
                          expression: "getAnnotation(remarkTypes.REP).remarks",
                        },
                      ],
                      staticClass: "textarea",
                      attrs: {
                        rows: _vm.rows,
                        disabled: !!_vm.savingAnnotations[_vm.remarkTypes.REP],
                      },
                      domProps: {
                        value: _vm.getAnnotation(_vm.remarkTypes.REP).remarks,
                      },
                      on: {
                        focus: function ($event) {
                          return _vm.captureAnnotationSnapshot(
                            _vm.remarkTypes.REP
                          )
                        },
                        blur: function ($event) {
                          return _vm.handleAnnotationBlur(_vm.remarkTypes.REP)
                        },
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.getAnnotation(_vm.remarkTypes.REP),
                            "remarks",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]
                ),
              ]),
              _c("div", { staticClass: "field" }, [
                _c("label", { staticClass: "label" }, [_vm._v("FIBER")]),
                _c(
                  "div",
                  {
                    staticClass: "control",
                    class: {
                      "is-loading":
                        _vm.savingAnnotations[_vm.remarkTypes.FIBER],
                    },
                  },
                  [
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.getAnnotation(_vm.remarkTypes.FIBER)
                            .remarks,
                          expression:
                            "getAnnotation(remarkTypes.FIBER).remarks",
                        },
                      ],
                      staticClass: "textarea",
                      attrs: {
                        rows: _vm.rows,
                        disabled:
                          !!_vm.savingAnnotations[_vm.remarkTypes.FIBER],
                      },
                      domProps: {
                        value: _vm.getAnnotation(_vm.remarkTypes.FIBER).remarks,
                      },
                      on: {
                        focus: function ($event) {
                          return _vm.captureAnnotationSnapshot(
                            _vm.remarkTypes.FIBER
                          )
                        },
                        blur: function ($event) {
                          return _vm.handleAnnotationBlur(_vm.remarkTypes.FIBER)
                        },
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.getAnnotation(_vm.remarkTypes.FIBER),
                            "remarks",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]
                ),
              ]),
              _c("div", { staticClass: "field" }, [
                _c("label", { staticClass: "label" }, [_vm._v("CD")]),
                _c(
                  "div",
                  {
                    staticClass: "control",
                    class: {
                      "is-loading": _vm.savingAnnotations[_vm.remarkTypes.CD],
                    },
                  },
                  [
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.getAnnotation(_vm.remarkTypes.CD).remarks,
                          expression: "getAnnotation(remarkTypes.CD).remarks",
                        },
                      ],
                      staticClass: "textarea",
                      attrs: {
                        rows: _vm.rows,
                        disabled: !!_vm.savingAnnotations[_vm.remarkTypes.CD],
                      },
                      domProps: {
                        value: _vm.getAnnotation(_vm.remarkTypes.CD).remarks,
                      },
                      on: {
                        focus: function ($event) {
                          return _vm.captureAnnotationSnapshot(
                            _vm.remarkTypes.CD
                          )
                        },
                        blur: function ($event) {
                          return _vm.handleAnnotationBlur(_vm.remarkTypes.CD)
                        },
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.getAnnotation(_vm.remarkTypes.CD),
                            "remarks",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]
                ),
              ]),
              _c("div", { staticClass: "field" }, [
                _c("label", { staticClass: "label" }, [_vm._v("PART")]),
                _c(
                  "div",
                  {
                    staticClass: "control",
                    class: {
                      "is-loading": _vm.savingAnnotations[_vm.remarkTypes.PART],
                    },
                  },
                  [
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.getAnnotation(_vm.remarkTypes.PART)
                            .remarks,
                          expression: "getAnnotation(remarkTypes.PART).remarks",
                        },
                      ],
                      staticClass: "textarea",
                      attrs: {
                        rows: _vm.rows,
                        disabled: !!_vm.savingAnnotations[_vm.remarkTypes.PART],
                      },
                      domProps: {
                        value: _vm.getAnnotation(_vm.remarkTypes.PART).remarks,
                      },
                      on: {
                        focus: function ($event) {
                          return _vm.captureAnnotationSnapshot(
                            _vm.remarkTypes.PART
                          )
                        },
                        blur: function ($event) {
                          return _vm.handleAnnotationBlur(_vm.remarkTypes.PART)
                        },
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.getAnnotation(_vm.remarkTypes.PART),
                            "remarks",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]
                ),
              ]),
              _c("div", { staticClass: "field" }, [
                _c("label", { staticClass: "label" }, [_vm._v("MISC")]),
                _c(
                  "div",
                  {
                    staticClass: "control",
                    class: {
                      "is-loading": _vm.savingAnnotations[_vm.remarkTypes.MISC],
                    },
                  },
                  [
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.getAnnotation(_vm.remarkTypes.MISC)
                            .remarks,
                          expression: "getAnnotation(remarkTypes.MISC).remarks",
                        },
                      ],
                      staticClass: "textarea",
                      attrs: {
                        rows: _vm.rows,
                        disabled: !!_vm.savingAnnotations[_vm.remarkTypes.MISC],
                      },
                      domProps: {
                        value: _vm.getAnnotation(_vm.remarkTypes.MISC).remarks,
                      },
                      on: {
                        focus: function ($event) {
                          return _vm.captureAnnotationSnapshot(
                            _vm.remarkTypes.MISC
                          )
                        },
                        blur: function ($event) {
                          return _vm.handleAnnotationBlur(_vm.remarkTypes.MISC)
                        },
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.getAnnotation(_vm.remarkTypes.MISC),
                            "remarks",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]
                ),
              ]),
            ]),
            _c("div", { staticClass: "column" }, [
              _c("div", { staticClass: "field" }, [
                _c("label", { staticClass: "label" }, [_vm._v("RWA")]),
                _c(
                  "div",
                  {
                    staticClass: "control",
                    class: {
                      "is-loading": _vm.savingAnnotations[_vm.remarkTypes.RWA],
                    },
                  },
                  [
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.getAnnotation(_vm.remarkTypes.RWA).remarks,
                          expression: "getAnnotation(remarkTypes.RWA).remarks",
                        },
                      ],
                      staticClass: "textarea",
                      attrs: {
                        rows: _vm.rows,
                        disabled: !!_vm.savingAnnotations[_vm.remarkTypes.RWA],
                      },
                      domProps: {
                        value: _vm.getAnnotation(_vm.remarkTypes.RWA).remarks,
                      },
                      on: {
                        focus: function ($event) {
                          return _vm.captureAnnotationSnapshot(
                            _vm.remarkTypes.RWA
                          )
                        },
                        blur: function ($event) {
                          return _vm.handleAnnotationBlur(_vm.remarkTypes.RWA)
                        },
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.getAnnotation(_vm.remarkTypes.RWA),
                            "remarks",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]
                ),
              ]),
              _c("div", { staticClass: "field" }, [
                _c("label", { staticClass: "label" }, [_vm._v("PAINT")]),
                _c(
                  "div",
                  {
                    staticClass: "control",
                    class: {
                      "is-loading":
                        _vm.savingAnnotations[_vm.remarkTypes.PAINT],
                    },
                  },
                  [
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.getAnnotation(_vm.remarkTypes.PAINT)
                            .remarks,
                          expression:
                            "getAnnotation(remarkTypes.PAINT).remarks",
                        },
                      ],
                      staticClass: "textarea",
                      attrs: {
                        rows: _vm.rows,
                        disabled:
                          !!_vm.savingAnnotations[_vm.remarkTypes.PAINT],
                      },
                      domProps: {
                        value: _vm.getAnnotation(_vm.remarkTypes.PAINT).remarks,
                      },
                      on: {
                        focus: function ($event) {
                          return _vm.captureAnnotationSnapshot(
                            _vm.remarkTypes.PAINT
                          )
                        },
                        blur: function ($event) {
                          return _vm.handleAnnotationBlur(_vm.remarkTypes.PAINT)
                        },
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.getAnnotation(_vm.remarkTypes.PAINT),
                            "remarks",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]
                ),
              ]),
              _c("div", { staticClass: "field" }, [
                _c("label", { staticClass: "label" }, [_vm._v("CRUSH")]),
                _c(
                  "div",
                  {
                    staticClass: "control",
                    class: {
                      "is-loading":
                        _vm.savingAnnotations[_vm.remarkTypes.CRUSH],
                    },
                  },
                  [
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.getAnnotation(_vm.remarkTypes.CRUSH)
                            .remarks,
                          expression:
                            "getAnnotation(remarkTypes.CRUSH).remarks",
                        },
                      ],
                      staticClass: "textarea",
                      attrs: {
                        rows: _vm.rows,
                        disabled:
                          !!_vm.savingAnnotations[_vm.remarkTypes.CRUSH],
                      },
                      domProps: {
                        value: _vm.getAnnotation(_vm.remarkTypes.CRUSH).remarks,
                      },
                      on: {
                        focus: function ($event) {
                          return _vm.captureAnnotationSnapshot(
                            _vm.remarkTypes.CRUSH
                          )
                        },
                        blur: function ($event) {
                          return _vm.handleAnnotationBlur(_vm.remarkTypes.CRUSH)
                        },
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.getAnnotation(_vm.remarkTypes.CRUSH),
                            "remarks",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]
                ),
              ]),
              _c("div", { staticClass: "field" }, [
                _c("label", { staticClass: "label" }, [_vm._v("MECH")]),
                _c(
                  "div",
                  {
                    staticClass: "control",
                    class: {
                      "is-loading": _vm.savingAnnotations[_vm.remarkTypes.MECH],
                    },
                  },
                  [
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.getAnnotation(_vm.remarkTypes.MECH)
                            .remarks,
                          expression: "getAnnotation(remarkTypes.MECH).remarks",
                        },
                      ],
                      staticClass: "textarea",
                      attrs: {
                        rows: _vm.rows,
                        disabled: !!_vm.savingAnnotations[_vm.remarkTypes.MECH],
                      },
                      domProps: {
                        value: _vm.getAnnotation(_vm.remarkTypes.MECH).remarks,
                      },
                      on: {
                        focus: function ($event) {
                          return _vm.captureAnnotationSnapshot(
                            _vm.remarkTypes.MECH
                          )
                        },
                        blur: function ($event) {
                          return _vm.handleAnnotationBlur(_vm.remarkTypes.MECH)
                        },
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.getAnnotation(_vm.remarkTypes.MECH),
                            "remarks",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]
                ),
              ]),
              _c("div", { staticClass: "field" }, [
                _c("label", { staticClass: "label" }, [_vm._v("OPG")]),
                _c(
                  "div",
                  {
                    staticClass: "control",
                    class: {
                      "is-loading": _vm.savingAnnotations[_vm.remarkTypes.OPG],
                    },
                  },
                  [
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.getAnnotation(_vm.remarkTypes.OPG).remarks,
                          expression: "getAnnotation(remarkTypes.OPG).remarks",
                        },
                      ],
                      staticClass: "textarea",
                      attrs: {
                        rows: _vm.rows,
                        disabled: !!_vm.savingAnnotations[_vm.remarkTypes.OPG],
                      },
                      domProps: {
                        value: _vm.getAnnotation(_vm.remarkTypes.OPG).remarks,
                      },
                      on: {
                        focus: function ($event) {
                          return _vm.captureAnnotationSnapshot(
                            _vm.remarkTypes.OPG
                          )
                        },
                        blur: function ($event) {
                          return _vm.handleAnnotationBlur(_vm.remarkTypes.OPG)
                        },
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.getAnnotation(_vm.remarkTypes.OPG),
                            "remarks",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]
                ),
              ]),
              _c("div", { staticClass: "field" }, [
                _c("label", { staticClass: "label" }, [_vm._v("SUBLET")]),
                _c(
                  "div",
                  {
                    staticClass: "control",
                    class: {
                      "is-loading": _vm.savingAnnotations[_vm.remarkTypes.SUBL],
                    },
                  },
                  [
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.getAnnotation(_vm.remarkTypes.SUBL)
                            .remarks,
                          expression: "getAnnotation(remarkTypes.SUBL).remarks",
                        },
                      ],
                      staticClass: "textarea",
                      attrs: {
                        rows: _vm.rows,
                        disabled: !!_vm.savingAnnotations[_vm.remarkTypes.SUBL],
                      },
                      domProps: {
                        value: _vm.getAnnotation(_vm.remarkTypes.SUBL).remarks,
                      },
                      on: {
                        focus: function ($event) {
                          return _vm.captureAnnotationSnapshot(
                            _vm.remarkTypes.SUBL
                          )
                        },
                        blur: function ($event) {
                          return _vm.handleAnnotationBlur(_vm.remarkTypes.SUBL)
                        },
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.$set(
                            _vm.getAnnotation(_vm.remarkTypes.SUBL),
                            "remarks",
                            $event.target.value
                          )
                        },
                      },
                    }),
                  ]
                ),
              ]),
            ]),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }